<template>
  <b-container class="sponsors bg-dark-brown">
    <section>
      <h2 id="splendid-partners-heading" class="text-center mb-4">
        Our splendid partners
      </h2>
      <b-row no-gutters class="justify-content-center">
        <Sponsor
          v-for="(partner, index) in splendidPartners"
          :key="index"
          :url="partner.url"
          :image="partner.image"
          :name="partner.name"
        />
      </b-row>

      <!-- Section for buggy screen reader -->
      <section aria-labelledby="media-partners-heading">
        <h2 id="media-partners-heading" class="text-center mt-5 mb-4 pt-3">
          Media and press partners
        </h2>
        <b-row no-gutters class="justify-content-center">
          <Sponsor
            v-for="(mediaPartner, index) in mediaPartners"
            :key="index"
            :url="mediaPartner.url"
            :image="mediaPartner.image"
            :name="mediaPartner.name"
          />
        </b-row>
      </section>

      <!-- Section for buggy screen reader -->
      <section
        aria-labelledby="best-companies-heading"
        v-if="bestCompanies.length"
      >
        <h2 id="best-companies-heading" class="text-center mt-5 mb-4 pt-3">
          Best companies
        </h2>
        <b-row no-gutters class="justify-content-center">
          <Sponsor
            v-for="(bestCompany, index) in bestCompanies"
            :key="index"
            :url="bestCompany.url"
            :image="bestCompany.image"
            :name="bestCompany.name"
          />
        </b-row>
      </section>

      <h2
        id="collaborations-heading"
        class="text-center mt-5 mb-4 pt-3"
        v-if="collaborations.length"
      >
        Organisations we support<br class="d-lg-none" aria-hidden="true" />
        and collaborate with
      </h2>
      <b-row
        no-gutters
        class="justify-content-center"
        v-if="collaborations.length"
      >
        <Sponsor
          v-for="(collab, index) in collaborations"
          :key="index"
          :url="collab.url"
          :image="collab.image"
          :name="collab.name"
        />
      </b-row>
    </section>
  </b-container>
</template>


<script>
import Sponsor from "@/components/Footer/Sponsor.vue";

export default {
  components: { Sponsor },
  data() {
    return {
      splendidPartners: [
        {
          url: "https://aws.amazon.com/developer/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1747283806/AWS_web25.png",
          name: "AWS",
        },
        {
          url: "https://se.devoteam.com/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1745909746/Devoteam_web25_nyb2ip.png",
          name: "Devoteam",
        },
        {
          url: "https://www.skatteverket.se",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1745916048/Skatteverket_web25_huxtju.png",
          name: "Skatteverket",
        },
        {
          url: "https://www.qt.io/quality-assurance",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1746721296/QTGroup_web25.png",
          name: "QT",
        },
        {
          url: "https://www.forsakringskassan.se/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1745912440/Forsakrningskassan_web25_h0dx5f.png",
          name: "Forsakringskassan",
        },
      ],
      mediaPartners: [
        {
          url: "https://developerspodcast.com/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1683114377/2023_web/logos/developers_pressmedia.png",
          name: "Developers podcast",
        },
        {
          url: "https://kodsnack.se/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1681295064/2023_web/logos/Kodsnack_mediapartners.png",
          name: "Kodsnack",
        },
        {
          url: "https://underjord.io/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1745915864/Underjord_web25_kklztj.png",
          name: "Underjord",
        },
        {
          url: "https://learnk8s.io/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1745912900/LearnK8s_web25_nmcekg.png",
          name: "LearnK8s",
        },
        {
          url: "https://kube.events/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1745912974/KubeEvents_web25_gftzuj.png",
          name: "KubeEvents",
        },
        {
          url: "https://www.manning.com/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1715946275/2024/Logos/Manning-web.png",
          name: "Manning",
        },
      ],
      bestCompanies: [],
      collaborations: [
        {
          url: "https://pinkprogramming.se/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1715176023/2024/Logos/pink_programming_logo_web.png",
          name: "Pink Programming",
        },
        {
          url: "https://www.redi-school.org/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1697041067/2023_web/logos/ReDi_School_logo_web.png",
          name: "ReDI School",
        },
        {
          url: "https://www.mediaevolution.se/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1719921826/2024/Logos/2.MEC-logo-web.png",
          name: "Media Evolution",
        },
        {
          url: "https://robo-solutions.com/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1745913143/RoboSolutions_jddhmj.png",
          name: "ROBO Solutions",
        },
        {
          url: "https://malmo.se",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1728302061/MalmoStad-web.png",
          name: "Malmö stad",
        },
        {
          url: "https://foocafe.org/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1726080272/FooCafe_Website.png",
          name: "Foo Café",
        },
        {
          url: "https://www.absurdumtemporaryart.se/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1745915719/Absurdum_web25_m24otd.png",
          name: "Absurdum Temporary Art",
        },
        {
          url: "https://backyard-sessions.se/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1715351695/2024/Logos/Backyard-web.png",
          name: "Backyard Sessions",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@use "@/styles/variables.scss" as *;

h2 {
  color: $bright-yellow;
  font-size: 18px;
  font-weight: 400;
  @media (min-width: 567px) {
    font-size: 24px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer/Sponsors.vue